import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormatRule, SignOptions } from '@utex/ui-kit';
import { useMoneyFormatter } from '../../hooks/useMoneyFormatter';
import { Money } from '../../types/Money';

interface Props {
  children: Money;
  sign?: SignOptions;
  rule?: FormatRule;
}

export const MoneyView: React.FC<Props> = ({ children, sign, rule }) => {
  const { i18n: {language } } = useTranslation('header');

  if (typeof children?.value !== 'number' || isNaN(children.value)) {
    return <>—</>;
  }

  const { formatted } = useMoneyFormatter({ money: children, sign, rule, locale: language });

  return <>{formatted} </>;
};
